// Environment-based Media component selector
// This file exports the appropriate Media component based on the environment
import { config } from '../../Services/config';
import MediaNajma from './MediaNajma';
import MediaNpm from './MediaNpm';

// Export the appropriate component based on environment
const Media = config.isNpm ? MediaNpm : MediaNajma;

export default Media;
